import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7705bfa5"
import script from "./addcustomerRuleMapping.js?vue&type=script&lang=js&external"
export * from "./addcustomerRuleMapping.js?vue&type=script&lang=js&external"
import style0 from "./addcustomerRuleMapping.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports